module.exports = __webpack_public_path__ + "static/media/gasOnline-app-slides-preview-details-image.4343b463.png";